import { render, staticRenderFns } from "./qpDetail.vue?vue&type=template&id=655785ee&scoped=true&"
import script from "./qpDetail.vue?vue&type=script&lang=js&"
export * from "./qpDetail.vue?vue&type=script&lang=js&"
import style0 from "./qpDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./qpDetail.vue?vue&type=style&index=1&id=655785ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655785ee",
  null
  
)

component.options.__file = "qpDetail.vue"
export default component.exports